<!-- 运维助手日志 -->
<style scoped lang="scss"></style>

<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/dify/message/page" getKey="rows" :columns="columns">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('yonghumingcheng')">
            <yi_data_select multiple :type="'customer_user'" :ids.sync="yt.conditions.createByList"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('chuangjianshijian')">
            <yi_time_input
              type="datetimerange"
              format="yyyy-MM-dd HH:mm:ss"
              :start.sync="yt.conditions.createTimeStart"
              :end.sync="yt.conditions.createTimeEnd"
            ></yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain>
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="clear">{{ $t('chongzhi') }}</el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #输入问题="scope">
        <span :title="scope.row.prompt">{{ scope.row.prompt }}</span>
      </template>
      <template #返回内容="scope">
        <span :title="scope.row.answer">{{ scope.row.answer }}</span>
      </template>
    </yi_curd_table>
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'web_production_management_omhelper_log_list',
  data() {
    return {
      createTimeStart: 0,
      createTimeEnd: 0,
      columns: [
        {
          label: 'yonghumingcheng',
          prop: 'createByObject.nickname',
          width: 140
        },
        {
          label: '输入问题',
          prop: 'prompt',
          minWidth: 220
        },
        {
          label: '返回内容',
          prop: 'answer',
          minWidth: 280
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          format: 'YYYY-MM-DD HH:mm:ss',
          width: 180
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.setStartAndEndTimes();
      this.yt.get(1);
    }, 300);
  },
  methods: {
    setStartAndEndTimes() {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth();
      const firstDayOfMonth = new Date(year, month, 1, 0, 0, 0);
      const lastDayOfMonth = new Date(year, month + 1, 0, 23, 59, 59);
      this.createTimeStart = firstDayOfMonth.getTime();
      this.createTimeEnd = lastDayOfMonth.getTime();
      this.$set(this.yt.conditions, 'createTimeStart', this.createTimeStart);
      this.$set(this.yt.conditions, 'createTimeEnd', this.createTimeEnd);
    },
    clear() {
      this.setStartAndEndTimes();
      this.yt.clear({
        createTimeStart: this.createTimeStart,
        createTimeEnd: this.createTimeEnd
      });
    }
  }
};
</script>
